import React, { useRef } from "react";

import { Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CustomSnackbar from "./CustomSnackbar";
import SupportFeedbackButton from "../features/support_tickets/SupportFeedbackButton";
import { hideToast } from "../app/uiSlice";

const Layout = () => {
  const scrollRef = useRef(null);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const location = useLocation();
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.ui.toast);

  const NO_NAVBAR_PATHS = ['/login', '/onboarding', '/pending-approval'];
  const hideNavbar = NO_NAVBAR_PATHS.includes(location.pathname);

  // The footer is chrome for browsing pages. The live roleplay screens are full-viewport
  // and dark, with their own controls, so a white strip carrying a provider line reads as
  // the page having ended — and it is the one screen a trainee is being recorded on.
  // Superset of NO_NAVBAR_PATHS: /login already carries the provider line inside the
  // sign-in panel, and onboarding is deliberately chrome-free.
  const NO_FOOTER_PATHS = [...NO_NAVBAR_PATHS, '/audio-orb-openai', '/audio-orb'];
  const hideFooter = NO_FOOTER_PATHS.includes(location.pathname);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      // backgroundColor:"#f5f5f7", 
      height: "100%"}}>
      {!hideNavbar && (
        <>
          <Navbar />
          <div style={{ height: "50px",  }} />
        </>
      )}
      <div
        style={{
          // paddingLeft: isMobile ? "1em" : "2em",
          // paddingRight: isMobile ? "1em" : "2em",
          // paddingTop: isMobile ? "20px" : "40px",
          // height: "100vh",
        }}
      >
        <Outlet ref={scrollRef} />
      </div>
      {!hideFooter && <Footer />}
      <CustomSnackbar
        visible={toast.visible}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        onClose={() => dispatch(hideToast())}
      />
      <SupportFeedbackButton />
    </div>
  );
};

export default Layout;
